export default {
  periodo: null,
  indicadoresAbertos: [],
  notas: [],
  indicadorSelectedId : null
}



// WEBPACK FOOTER //
// ./src/features/Relatorio/store/state.js